import { ContextDateRange } from "@mapmycustomers/shared/types/chat/FieldAgentContext";

import { formatDate } from "@app/util/formatters";

// The contract's plain-date window for a request range, or none when the request sent no range.
const toContextDateRange = (range: [Date, Date] | undefined): ContextDateRange | undefined =>
  range && { from: formatDate(range[0], "yyyy-MM-dd"), to: formatDate(range[1], "yyyy-MM-dd") };

export default toContextDateRange;
